

import React from 'react';

const ArticleHistoryModal = ({ isOpen, onClose, history, isDarkMode, loading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
      <div className={`rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        {/* Header */}
        <div className={`px-6 py-4 flex-shrink-0 ${isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-r from-primary-600 to-primary-700'}`}> 
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center mr-3">
                <i className="fas fa-history text-white text-lg"></i>
              </div>
              <div>
                <h2 className="text-xl font-bold text-white">Historique de l'article</h2>
                <p className="text-primary-100 text-sm">Toutes les interventions passées pour cet équipement</p>
              </div>
            </div>
            <button 
              onClick={onClose}
              className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
            >
              <i className="fas fa-times text-xl"></i>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="overflow-y-auto flex-1" style={{ maxHeight: 'calc(90vh - 120px)' }}>
          <div className="p-6">
            {loading ? (
              <div className="flex justify-center items-center py-8">
                <span className="loader mr-2"></span>
                <span className="text-gray-400">Chargement de l'historique...</span>
              </div>
            ) : history && history.length > 0 ? (
              history.map((entry, idx) => (
                <div
                  key={idx}
                  className={`rounded-xl p-5 shadow ${isDarkMode ? 'bg-gray-800 border border-gray-700' : 'bg-gray-100 border border-gray-200'}${idx !== history.length - 1 ? ' mb-5' : ''}`}
                >
                  <div className="flex items-center mb-2">
                    <span className="font-semibold text-primary-500 mr-2">
                      {new Date(entry.date).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </span>
                    <span className="text-xs text-gray-400 ml-auto">{entry.article?.designation || ''}</span>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {entry.pieceDeRechangeEtServices && entry.pieceDeRechangeEtServices.length > 0 ? (
                      entry.pieceDeRechangeEtServices.map((piece, i) => (
                        <span
                          key={i}
                          className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${isDarkMode ? 'bg-primary-700 text-white' : 'bg-primary-100 text-primary-700'} shadow`}
                        >
                          {piece.famille ? <span className="font-semibold">{piece.famille}: </span> : null}
                          {piece.designation}
                        </span>
                      ))
                    ) : (
                      <span className="text-gray-400 text-sm">Aucune pièce/service</span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-gray-400 py-8">
                <i className="fas fa-history text-2xl mb-2 block" />
                Aucun historique trouvé pour cet article.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleHistoryModal;